import * as angular from "angular";

export class EffortService {
    private apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/effort";
    }

    all(): Promise<object> {
        return this.$http.get(this.apiRoot + "/all");
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.apiRoot, data);
    }

    update(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/" + data.id, data);
    }

    archive(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/archive/" + data.id, data);
    }

    delete(data: any): Promise<object> {
        return this.$http.delete(this.apiRoot + "/" + data.id, data);
    }
}

angular.module("vcServices").service("EffortService", EffortService);
